import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Text, Flex, Icon } from '@chakra-ui/react';
import FeatherIcon from '@ailibs/feather-react-ts';
import { PiBookOpenText, PiHandTap, PiTrophy } from 'react-icons/pi';
import { PageContent } from '@/components/PageContent';
import { SectionBox } from '@/components/SectionBox';
import { applicationBreadcrumb } from './breadcrumb';
import { ShortcutCard } from '../Home/components/ShortcutCard';
import { ReactComponent as TeamShirtIcon } from '@/assets/icons/TeamShirt.svg';
import { ReactComponent as BannerHomeIcon } from '@/assets/icons/BannerHome.svg';
import { ReactComponent as BaladAppIcon } from '@/assets/icons/BaladApp-icon.svg';
import { ReactComponent as ChallengeIcon } from '@/assets/icons/Challenge.svg';

type Link = {
  label: string;
  url: string;
  icon: ReactNode;
  iconWidth?: string;
  iconHeight?: string;
};
const links: Array<Link> = [
  { label: 'Página Inicial', url: '/application/home', icon: <FeatherIcon name='home' /> },
  // { label: 'Carteirinha', url: '/application/card', icon: <FeatherIcon name='credit-card' /> },
  { label: 'Notícias', url: '/application/news', icon: <PiBookOpenText /> },
  { label: 'Redes Sociais', url: '/application/social-media', icon: <FeatherIcon name='thumbs-up' /> },
  { label: 'Calendário', url: '/application/calendar', icon: <FeatherIcon name='calendar' /> },
  { label: 'Competições', url: '/application/championships', icon: <PiTrophy /> },
  { label: 'Equipe', url: '/application/team', icon: <Icon as={TeamShirtIcon} /> },
  { label: 'História', url: '/application/history', icon: <FeatherIcon name='book' /> },
  { label: 'Mapa de Indicações', url: '/application/indications-map', icon: <FeatherIcon name='map-pin' /> },
  { label: 'Canal de Vídeos', url: '/application/videos-channel', icon: <FeatherIcon name='tv' /> },
  { label: 'Banners na Home', url: '/application/banners-home', icon: <Icon as={BannerHomeIcon} /> },
  { label: 'Loja', url: '/application/store', icon: <FeatherIcon name='shopping-cart' /> },
  // { label: 'Clube de Benefícios', url: '/application/benefits-club', icon: <FeatherIcon name='gift' /> },
  // { label: 'Materiais Exclusivos', url: '/application/exclusive-material', icon: <FeatherIcon name='box' /> },
  { label: 'Áreas Interativas', url: '/application/interactive-area', icon: <Icon as={PiHandTap} /> },
  { label: 'BaladAPP', url: '/application/balada-app', icon: <Icon as={BaladAppIcon} /> },
  { label: 'Desafios', url: '/application/challenge', icon: <Icon as={ChallengeIcon} />, iconHeight: '60px', iconWidth: '60px' },
];

export const Application = () => {
  return (
    <PageContent title='APLICATIVO' breadcrumbItems={applicationBreadcrumb}>
      <SectionBox bodyProps={{ gap: 'small' }}>
        <Text fontWeight='bold'>Configurações do Aplicativo</Text>

        <Flex gap='xxsmall' flexWrap='wrap'>
          {links?.map(link => (
            <Link key={link.url} to={link.url}>
              <ShortcutCard
                label={link.label}
                icon={link.icon}
                {...(link.iconWidth && { iconWidth: link.iconWidth })}
                {...(link.iconHeight && { iconHeight: link.iconHeight })}
              />
            </Link>
          ))}
        </Flex>
      </SectionBox>
    </PageContent>
  );
};
